export function contactsForm() {
    document.addEventListener("DOMContentLoaded", function () {
        let pardotForm = document.querySelector("#pardotForm");

        if (pardotForm) {
            let pardotButton = pardotForm.querySelector(".btn");
            let pardotSub = pardotForm.getAttribute("data-sub");
            let pardotID = pardotForm.getAttribute("data-id");
            let pardotAction = "https://" + pardotSub + ".ddn.com" + pardotID;

            let children = pardotForm.querySelectorAll(
                "input, textarea, select:not(.pardot-form__disabled)"
            );

            children.forEach((element) => {
                element.addEventListener("blur", function () {
                    if (element.classList.contains("error")) {
                        element.classList.remove("error");
                    }
                })
            })

            pardotButton.addEventListener("click", function (e) {
                e.preventDefault();

                let findEmpty = Array.from(children).find((element) => {
                    if (element.value.length < 1) {
                        return true;
                    }
                    return false;
                });
                if (findEmpty) {
                    if (findEmpty.tagName === "SELECT") {
                        findEmpty.parentElement.classList.add("select-error");
                    }
                    $(findEmpty).addClass("error");
                    console.log(findEmpty.focus());
                } else {
                    pardotForm.action = pardotAction;
                    pardotForm.submit();
                }
            });

            let pardotTrigger = pardotForm.querySelector(".pardot-form__trigger");
            let pardotDisabled = pardotForm.querySelector(".pardot-form__disabled");

            if (pardotDisabled) {
                let pardotDisabledParent = pardotDisabled.closest('div');
                if (pardotDisabledParent) {
                    pardotDisabledParent.classList.add("pardot-form__disabled");
                }


                if (pardotTrigger) {
                    let usState = pardotForm.querySelector('optgroup[label*="State"]');
                    let caProvince = pardotForm.querySelector('optgroup[label*="Province"]');

                    pardotTrigger.addEventListener("change", function (e) {
                        this.parentElement.classList.remove("select-error");
                        if (e.target.value == "United States") {
                            pardotDisabledParent.classList.add("us-active")
                            pardotDisabledParent.classList.remove("pardot-form__disabled", "ca-active");
                            pardotDisabled.classList.remove("pardot-form__disabled");
                            pardotDisabled.required = true;
                            caProvince.style.display = "none";
                            usState.style.display = "block";
                            usState.querySelector('option[value=""]').selected = "selected";
                        } else if (e.target.value == "Canada") {
                            pardotDisabledParent.classList.add("ca-active")
                            pardotDisabledParent.classList.remove("pardot-form__disabled", "us-active");
                            pardotDisabled.classList.remove("pardot-form__disabled");
                            pardotDisabled.required = true;
                            usState.style.display = "none";
                            caProvince.style.display = "block";
                            caProvince.querySelector('option[value=""]').selected = "selected";
                        } else {
                            pardotDisabledParent.classList.add("pardot-form__disabled");
                            pardotDisabled.classList.add("pardot-form__disabled");
                            pardotDisabled.required = false;
                            pardotDisabled.value = "";
                        }
                        jcf.destroy();
                        jcf.replaceAll();
                    });
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contactsForm.js